<template>
<div class="chapter">
<div class="inner_page">
<section class="element element-non-bodymatter element-container-single element-type-image" id="full-page-image">
<div class="image-element-block image-element-aspect-tall">
<div class="image-element-size-container">
<img alt="" class="image-element-image" src="images/vicki-ann-copy.jpg"/>
</div>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fullpageimage.vue?1f76b08e